export const _ADD               = "gu2KoSAitOuELS8uvVOzUQ==";
export const _EDIT              = "RdkjEidS2OImt1tHATOkEQ==";
export const _VIEW              = "xsFI1KaIt2V7eLDcE6s/3g==";
export const _DELETE            = "ffbOI1xbR30Dm3bfvhNdZg==";
export const _RECOVER           = "7RwJtUlbj+Q+EXG/ddB3qg==";
export const _LIST              = "vQAKAe30wXL8R1glTSzwBw==";
export const _TRASH             = "UvsjA2FP89zcqtZonbMroQ==";
export const _LIST_TYPE_USER    = "gxlcAFQaWMxypnPnmAdHWQ==";
export const _LIST_USER         = "gEdCSxFfxQuWuUxpUy4GXw==";